import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import config from 'config';
import { useAxios } from 'context/AxiosContextProvider';
import useServiceRecordQuery from 'hooks/useServiceRecordQuery';

async function reopenSR(axios: AxiosInstance, id: number) {
  const { data } = await axios.put(`${config.apiBaseUrl}/op/v1/service-record/${id}/reopen`);
  return data;
}

export default function useReopenServiceRecordMutation(id: number) {
  const axios = useAxios();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => reopenSR(axios, id),
    onSuccess: () => {
      return queryClient.invalidateQueries({
        queryKey: useServiceRecordQuery.getKey(id),
      });
    },
  });
}
